import React, { createContext, useContext, ReactNode } from 'react';
import { useGlobalLoader } from '../hooks/useGlobalLoader';

interface GlobalLoaderContextType {
  isLoading: boolean;
  message: string;
  showLoader: (message?: string) => void;
  hideLoader: () => void;
  updateMessage: (message: string) => void;
}

const GlobalLoaderContext = createContext<GlobalLoaderContextType | undefined>(undefined);

export const useGlobalLoaderContext = () => {
  const context = useContext(GlobalLoaderContext);
  if (context === undefined) {
    throw new Error('useGlobalLoaderContext must be used within a GlobalLoaderProvider');
  }
  return context;
};

interface GlobalLoaderProviderProps {
  children: ReactNode;
}

export const GlobalLoaderProvider: React.FC<GlobalLoaderProviderProps> = ({ children }) => {
  const loader = useGlobalLoader();

  return (
    <GlobalLoaderContext.Provider value={loader}>
      {children}
    </GlobalLoaderContext.Provider>
  );
};
